import CarouselImageItem from '@/components/Carousel/Image';
import CarouselVideoItem from '@/components/Carousel/Video';
import { View } from '@/components/Theme';
import isEqual from 'lodash/isEqual';
import { memo, useMemo } from 'react';

const CarouselItem = ({item, dimension, thumbnails, thumbnailStyle, showPlus}) => {

    const ViewTemplate = useMemo(() => {
        if (!item?.mediaType) 
            return View;

        return item?.mediaType?.includes('image') ? CarouselImageItem : CarouselVideoItem;
    }, [item?.mediaType, item?.youtubeId]);

    return (
        <ViewTemplate 
            showPlus={showPlus} 
            thumbnailStyle={thumbnailStyle} 
            path={item?.uri} 
            dimension={dimension} 
            thumbnails={thumbnails}
            videoId={item?.youtubeId ?? null} 
        />
    );
};

export default memo(CarouselItem, isEqual);